"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InLineFreightSolutions = void 0;
exports.InLineFreightSolutions = {
    id: 'inLineFreightSolutions',
    companyName: 'In Line Freight Solutions',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'inLineFreightSolutions',
    },
    isInternal: false,
    isActive: true,
    countries: ['ZA'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5MaW5lRnJlaWdodFNvbHV0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9JbkxpbmVGcmVpZ2h0U29sdXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsc0JBQXNCLEdBQVU7SUFDekMsRUFBRSxFQUFFLHdCQUF3QjtJQUM1QixXQUFXLEVBQUUsMkJBQTJCO0lBQ3hDLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLHdCQUF3QjtLQUNsQztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==